import React from 'react';
import styles from './HtsQuestionForm.module.scss';

interface StepHeaderProps {
  stepNumber: number;
  title: string;
  description?: React.ReactNode;
}

export const StepHeader: React.FC<StepHeaderProps> = ({ stepNumber, title, description }) => (
  <div className={styles.stepHeader}>
    <div className={styles.stepEyebrow}>Step {stepNumber} of 6</div>
    <div className={styles.stepTitle}>{title}</div>
    {description && <div className={styles.stepDescription}>{description}</div>}
  </div>
);

export default StepHeader;
